import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import * as Sentry from '@sentry/browser';
import './index.scss'
import App from 'components/App'
import { store, history } from 'init'
import 'rxjs'
import 'react-toastify/dist/ReactToastify.css'
import dotenv from 'dotenv'
import { initPageviewTrack } from 'common/utils/googleTagManager'

dotenv.config()

Sentry.init({dsn: "https://21567716c7c14f76917e33f463f2d96a@sentry.io/1488698"});

window.onload = initPageviewTrack(history, store)

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  document.getElementById('root')
)

if (process.env.NODE_ENV === 'development') {
  const registerServiceWorker = require('./registerServiceWorker').default
  registerServiceWorker()
}
